<template>
  <div>
    <Modal
      v-model="show"
      :title="type == 'add' ?$t('add'):$t('edit')"
      :mask-closable="false"
      width="800"
      @on-cancel="cancel">
      <div class="modal">
        <Form ref="form" :model="form" :rules="ruleInline" inline :label-width="120" label-colon>
          <Tabs :value="tabs" @on-click="ontabs" :animated="false">
            <TabPane :label="$t('Langue.zn')" name="1">
              <div class="tabs_item">
                <FormItem class="item_input" prop="zh-cn_cname" :label="$t('Tags.name')">
                  <Input type="text" v-model="form['zh-cn_cname']" placeholder="请输入标签名称"></Input>
                </FormItem>
              </div>
            </TabPane>
            <TabPane :label="$t('Langue.tw')" name="2">
              <div class="tabs_item">
                <FormItem class="item_input" prop="zh-tw_cname" :label="$t('Tags.name')">
                  <Input type="text" v-model="form['zh-tw_cname']" placeholder="請輸入標籤名稱"></Input>
                </FormItem>
              </div>
            </TabPane>
            <TabPane :label="$t('Langue.en')" name="3">
              <div class="tabs_item">
                <FormItem class="item_input" prop="en_cname" :label="$t('Tags.name')">
                  <Input
                    type="text"
                    v-model="form.en_cname"
                    placeholder="Please enter a label name"
                  ></Input>
                </FormItem>
              </div>
            </TabPane>
          </Tabs>
          <div class="item">
            <FormItem :label="$t('Tags.wi')" prop="score">
              <InputNumber
                :min="1"
                v-model="form.score"
                :placeholder="tabs == 1 ? '请输入权重':tabs == 2 ? '請輸入權重':'Please enter the weight'"
              ></InputNumber>
            </FormItem>
            <FormItem prop="sort_id" :label="$t('sort')">
              <InputNumber
                :min="1"
                v-model="form.sort_id"
                :placeholder="tabs == 1 ? '请输入排序顺序':tabs == 2 ? '請輸入排序順序':'Please enter the sort order'"
              ></InputNumber>
            </FormItem>
            <FormItem :label="$t('status')" prop="status">
              <i-Switch size="large" v-model="form.status" true-value="1" false-value="0" />
            </FormItem>
            <FormItem :label="$t('multiples')" prop="multiple">
              <i-Switch size="large" v-model="form.multiple" true-value="1" false-value="0" />
            </FormItem>
          </div>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="cancel()">{{ $t("cancel") }}</Button>
        <Button type="primary" @click="submit('form')">{{ $t("sure") }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    itemObj: Object,
    type: String
  },
  data () {
    return {
      tabs: '1',
      switch1: false,
      form: {
        cat_id: null,
        sort_id: null,
        en_cname: "",
        en_cdesc: "",
        "zh-cn_cname": "",
        "zh-cn_cdesc": "",
        "zh-tw_cdesc": "",
        "zh-tw_cname": "",
        score: null,
        status: 0,
        multiple: 0,
      },
      ruleInline: {
        'zh-cn_cname': [
          {
            required: true,
            message: this.$t("Ad.cname_input"),
            trigger: "blur"
          }
        ],
        'zh-tw_cname': [
          {
            required: true,
            message: this.$t("Ad.cname_input"),
            trigger: "blur"
          }
        ],
        en_cname: [
          {
            required: true,
            message: this.$t("Ad.cname_input"),
            trigger: "blur"
          }
        ],
        score: [
          {
            type: 'number',
            required: true,
            message: this.$t("score_input"),
            trigger: "blur"
          }
        ],
        status: [
          {
            required: true,
            message: ' ',
            trigger: "blur"
          }
        ],
        multiple: [
          {
            required: true,
            message: ' ',
            trigger: "blur"
          }
        ],
        sort_id: [
          {
            type: 'number',
            required: true,
            message: this.$t('sort_input'),
            trigger: 'blur'
          }
        ],
      },
      show: this.modal
    }

  },
  created () {
    this.info()
  },
  mounted () {

  },
  methods: {
    info () {
      if (this.type != 'add') {
        this.$base.showLoading();
        this.$request.sendPost(
          'base-mtag/before-upd',
          { cat_id: this.itemObj.cat_id },
          (success, data, error) => {
            this.$base.hideLoading();
            if (!success) return this.$base.alertErr(error.errmsg);
            this.form = data.info
            this.form.score = this.form.score * 1
            this.form.sort_id = this.form.sort_id * 1
          }
        );
      }
    },
    cancel () {
      this.$emit('cancel');
    },
    error () {
      this.$Message.error(this.$t("improve_information"));
    },
    ontabs (item) {
      this.tabs = item
    },
    submit (name) {
      console.log(this.form);
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$base.showLoading();
          this.$request.sendPost(
            this.type == 'add' ? 'base-mtag/add' : 'base-mtag/upd',
            this.form,
            (success, data, error) => {
              this.$base.hideLoading();
              if (!success) return this.$base.alertErr(error.errmsg);
              this.cancel()
              this.$emit('onOk');
            }
          );
        } else {
          this.error()
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .modal {
  .ivu-tabs .ivu-tabs-tabpane {
    margin-top: 40px;
  }
  .item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 80%;
    margin: 0 0 20px 10%;
  }
  .tabs_item {
    width: 80%;
    margin: 20px 0 0 10%;
    .item_input {
      width: 100%;
      padding-right: 10px;
    }
  }
  .ivu-tabs-nav-scroll {
    display: flex;
    justify-content: center;
  }
  .demo-upload-list {
    display: inline-block;
    width: 150px;
    height: 150px;
    text-align: center;
    line-height: 100px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    margin-right: 4px;
  }
  .demo-upload-list img {
    width: 100%;
    height: 100%;
    border: 1px solid #dcdee2;
  }
  .ivu-upload-drag {
    height: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/edu/baseMtag/module/baseMtag_edit.vue